import { CardModel, PileCardModel } from "../../interface/game";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function pileRevealTopPolicy(): PileAnnotationPolicy {
    return (pile: PileCardModel[], cards: {[key: string]: CardModel}): PileCardModel[] => {
        if (pile.length > 0) {
            const topCardId = pile[pile.length - 1].id;
            cards[topCardId] = {...cards[topCardId], faceUp: true};
        }
        return pile;
    }
}